import * as Scrivito from "scrivito";
import cx from "classnames";
import React from "react";
import { SideBarWrapper } from "components/LeftSidebar/SideBarWrapper";
import { useWizardData } from "hooks/wizardHooks";
import {
  useIsMultipleQuestionnaireListStep,
  useIsTopology,
  useStep,
  useSubType,
} from "stores/wizardStore";
import { WizardLeftSidebarSystemInfo } from "objs/_ConfiguratorObjs/Wizard/WizardLeftSidebar/Extension/WizardLeftSidebarSystemInfo";
import { WizardTopologyMenu } from "objs/_ConfiguratorObjs/Wizard/WizardLeftSidebar/Extension/WizardTopologyMenu";
import { WizardLeftSidebarZoneProperties } from "./WizardLeftSidebarZoneProperties";
import s from "./WizardLeftSidebarExtension.module.scss";

export const WizardLeftSidebarExtension = Scrivito.connect(() => {
  const isTopology = useIsTopology();
  const step = useStep();
  const isMultipleQuestionnaireListStep = useIsMultipleQuestionnaireListStep();
  const subType = useSubType();

  const { wizardSubTypeObj, wizardItemStepsTitles = [] } =
    useWizardData(subType);
  return (
    <SideBarWrapper
      withToggle
      isFirstSidebar={false}
      width={408}
      toggleText="LEFT_SIDEBAR_CONFIGURATION_MENU"
      classNames="sideBarWidth"
      zIndex="-1"
      isRightSidebarToggle={false}
    >
      <div className={cx("h-100", s.wizardLeftSidebarTopology)}>
        <div
          className={cx(
            "d-flex flex-column h-100  bg-gray-800 pt-4 px-4 pb-3 w-100",
            s.wizardLeftSidebarTopology,
          )}
        >
          <div className="ms-4 mb-4">
            <h3 className="mb-1 text-uppercase text-white">
              {wizardItemStepsTitles[step]}
            </h3>
            <h6 className="fw-normal text-white">
              {wizardSubTypeObj?.get("title")}
            </h6>
          </div>
          {isMultipleQuestionnaireListStep && !isTopology && (
            <WizardLeftSidebarZoneProperties />
          )}
          {isTopology && (
            <>
              <WizardTopologyMenu />
              <WizardLeftSidebarSystemInfo />
            </>
          )}
        </div>
      </div>
    </SideBarWrapper>
  );
});
